// src/components/chatPolicy/PolicyImpactBadge.jsx
// Mini-badge debounced que llama /preview y muestra "Afecta a N (ver muestra)".
// Hover/click abre un popover con los primeros 10 usuarios.
import React, { useEffect, useRef, useState } from 'react';
import { Badge, OverlayTrigger, Popover } from 'react-bootstrap';
import { previewImpact } from '../../services/chatPolicyApi';

function hasAnyCriteria(c) {
    return ['puestos','unidades','sucursales','paises','users'].some(k => (c?.[k] || []).length > 0);
}

export default function PolicyImpactBadge({ mode, criteria }) {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const lastReq = useRef(0);

    useEffect(() => {
        if (!hasAnyCriteria(criteria)) {
            setData({ count: 0, sample: [], note: 'Sin criterios' });
            return;
        }
        const myReq = ++lastReq.current;
        setLoading(true);
        const t = setTimeout(() => {
            previewImpact(mode, criteria)
                .then(r => { if (myReq === lastReq.current) setData(r); })
                .catch(() => { if (myReq === lastReq.current) setData(null); })
                .finally(() => { if (myReq === lastReq.current) setLoading(false); });
        }, 350);
        return () => clearTimeout(t);
    }, [mode, JSON.stringify(criteria)]); // eslint-disable-line react-hooks/exhaustive-deps

    const popover = (
        <Popover id={`impact-pop-${mode}`} style={{ maxWidth: 320 }}>
            <Popover.Header style={{ fontSize: 12 }}>
                {data?.note ? data.note : `${data?.count || 0} usuarios coinciden`}
            </Popover.Header>
            <Popover.Body style={{ fontSize: 12, padding: 8 }}>
                {(data?.sample || []).length === 0 ? (
                    <em>Sin muestra</em>
                ) : (
                    <>
                        {data.sample.map(u => (
                            <div key={u._id} style={{ marginBottom: 2 }}>
                                <strong>{u.name}</strong>
                                <div style={{ color: '#64748b', fontSize: 11 }}>
                                    {u.puesto || u.role}
                                    {u.unidad ? ` · ${u.unidad}` : ''}
                                    {u.sucursal ? ` · ${u.sucursal}` : ''}
                                </div>
                            </div>
                        ))}
                        {data.count > data.sample.length && (
                            <div style={{ color: '#64748b', marginTop: 4 }}>… y {data.count - data.sample.length} más</div>
                        )}
                    </>
                )}
            </Popover.Body>
        </Popover>
    );

    const variant = data?.note ? 'secondary' : (data?.count > 0 ? 'info' : 'light');
    const text    = loading
        ? '…'
        : (data?.note ? data.note : `Afecta a ${data?.count ?? 0}`);

    return (
        <OverlayTrigger placement="top" trigger={['hover', 'focus', 'click']} overlay={popover}>
            <Badge bg={variant} text={variant === 'light' ? 'dark' : undefined}
                   style={{ fontSize: 10, fontWeight: 500, cursor: 'help' }}>
                {text}
            </Badge>
        </OverlayTrigger>
    );
}
